import { Injectable } from '@angular/core';
import { IQuestion, IOccupations, IAddresses, IPostalCodeAreas, AssetType, QuestionType, SharedConfig, IProgressChecker, IVheicleType } from '@takectrl-multiapp/svcs-share-config';
import { APIHttpService } from './api-http.service';
import { ICtrlResponse } from '../interfaces/api.interface';
import { finalize, Observable, shareReplay, switchMap, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class APIQuestionService {
  occupation: IOccupations;
  constructor(private readonly ctrlApiHttpService: APIHttpService) {}

  getUnderwritingQuestions(): Observable<ICtrlResponse<IProgressChecker>> {
    return this.ctrlApiHttpService.get(`/progress/questions/`);
  }

  getTheUWQsOnly(asset_type): Observable<ICtrlResponse<IProgressChecker>> {
    return this.ctrlApiHttpService.get(`/admin/progress/questions/${asset_type}/`);
  }

  setAddress(address: IAddresses): Observable<ICtrlResponse<IAddresses>> {
    return this.ctrlApiHttpService.post(`/addresses/`, address);
  }

  getProgressCheckerQuestions(asset_type: string, asset_id: number): Observable<ICtrlResponse<IProgressChecker>> {
    return this.ctrlApiHttpService.get(`/progress/check/${asset_type}/${asset_id}/`);
  }

  searchApi(endpoint: string, search_value: string, additional_params): Observable<ICtrlResponse<any>> {
    return this.ctrlApiHttpService.get(`/${endpoint}/?search_str=${search_value}&${additional_params}`);
  }

  updateAddress(address: IAddresses): Observable<ICtrlResponse<IAddresses>> {
    return this.ctrlApiHttpService.patch(`/addresses/`, address);
  }

  getVehiclesTypes(): Observable<ICtrlResponse<Array<IVheicleType>>> {
    return this.ctrlApiHttpService.get(`/providers/premia/values/vehicle_types/`);
  }

  getCarMake(vehicle_code: string, year_of_manufacture: string): Observable<ICtrlResponse<any>> {
    return this.ctrlApiHttpService.get(`/providers/premia/values/vehicle_makes/?vehicle_type=${vehicle_code}&year_of_manufacture=${year_of_manufacture}`);
  }

  getMotorcycleMake(): Observable<ICtrlResponse<any>> {
    return this.ctrlApiHttpService.get(`/motorcycles/makes/`);
  }

  getCarModel(vehicle_code: string, code: string, year: string): Observable<ICtrlResponse<any>> {
    return this.ctrlApiHttpService.get(`/providers/premia/values/vehicle_models/?vehicle_type=${vehicle_code}&year_of_manufacture=${year}&make_code=${code}`);
  }

  getMotorcycleModel(code: string, year: string): Observable<ICtrlResponse<any>> {
    return this.ctrlApiHttpService.get(`/motorcycles/makes/${encodeURIComponent(year)}/models/${code}`);
  }

  getCarModelVariant(make: string, year: string, model: string): Observable<ICtrlResponse<any>> {
    return this.ctrlApiHttpService.get(`/motorvehicles/model/details/?year=${year}&make=${make}&model=${model}`);
  }

  getMotorcycleModelVariant(make: string, year: string, model: string): Observable<ICtrlResponse<any>> {
    return this.ctrlApiHttpService.get(`/motorcycles/model/details/?year=${year}&make=${make}&model=${model}`);
  }

  getPostalCodeAreas(code: string): Observable<ICtrlResponse<IPostalCodeAreas>> {
    return this.ctrlApiHttpService.post(
      `/address/postal`,
      { postal_code: code, suburb: '' },
      null
    );
  }

  getAddressFromString(addressResult: string): Observable<ICtrlResponse<IPostalCodeAreas>> {
    return this.ctrlApiHttpService.post(`/address/fulltext`, {'fulltext': addressResult}, null);
  }
}
